/**
 * 範例：您的表單關聯配置
 * 複製這個檔案並修改為您的需求
 */

import { FormRelationshipConfig } from '../relationship-types';

export const SampleFormConfig: FormRelationshipConfig = {
  formId: 'your-actual-form-id',    // 🔑 重要：這個必須與您在 Form Builder 中設定的 formid 一致
  formName: '您的表單名稱',
  description: '表單描述',
  relationships: [
    {
      id: 'sample_relationship_1',
      description: '範例：當選擇某個選項時，自動設定其他欄位',
      when: {
        field: 'sourceFieldName',        // 🎯 監聽的欄位名稱
        equals: 'triggerValue'           // 🎯 觸發條件
      },
      then: [
        {
          field: 'targetFieldName',      // 🎯 要影響的目標欄位
          action: 'setValue',            // 🎯 執行的動作
          value: 'newValue'              // 🎯 設定的新值
        }
      ]
    },

    // 更多關聯範例：
    {
      id: 'date_constraint_example',
      description: '日期限制範例',
      when: {
        field: 'urgencyLevel',
        equals: 'urgent'
      },
      then: [
        {
          field: 'dueDate',
          action: 'setMaxDate',
          value: 'today+7'              // 7天內完成
        },
        {
          field: 'priority',
          action: 'setValue',
          value: 'high'
        }
      ]
    },

    {
      id: 'conditional_required_example',
      description: '條件性必填範例',
      when: {
        field: 'needsApproval',
        equals: true
      },
      then: [
        {
          field: 'approver',
          action: 'setRequired',
          value: true
        },
        {
          field: 'approvalReason',
          action: 'setVisible',
          value: true
        }
      ]
    }
  ]
};